import { SchLocationDatetimeModalPage } from './sch-location-datetime-modal.page';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    component: SchLocationDatetimeModalPage,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SchLocationDatetimeModalPageRoutingModule {}
